export const STR_PAGE_SIZE = 10
